import { render, staticRenderFns } from "./model_setup_briefings_distribution.vue?vue&type=template&id=41d7199b"
import script from "./model_setup_briefings_distribution.vue?vue&type=script&lang=js"
export * from "./model_setup_briefings_distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports